import { FC, useEffect, useRef } from "react";
import katex from "katex";
import classNames from "classnames";
import { processKatexOutput } from "./katexFormatter";
import "katex/dist/katex.min.css";

interface Props {
  math: string;
  displayMode?: boolean;
  farsiDigits?: boolean;
}

const KatexRenderer: FC<Props> = ({
  math,
  displayMode = false,
  farsiDigits = false,
}) => {
  const containerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (!containerRef.current || !math) return;

    try {
      const html = katex.renderToString(math, {
        displayMode,
        throwOnError: false,
        strict: false,
        trust: true,
        output: "htmlAndMathml",
      });

      containerRef.current.innerHTML = html;

      processKatexOutput(containerRef.current, farsiDigits);
    } catch (error) {
      console.error("KaTeX error:", error);
      containerRef.current.textContent = math;
    }
  }, [math, displayMode, farsiDigits]);

  const Component = displayMode ? "div" : "span";

  return (
    <Component
      ref={containerRef as any}
      dir="ltr"
      className={classNames(
        displayMode ? "display-math text-center my-4" : "inline-math",
        farsiDigits ? "farsi-digits" : ""
      )}
    />
  );
};

export default KatexRenderer;
